const FetchApi = {


	ajaxNamespace:	window.FxOnlineStore.ajax_namespace,
	ajaxUrl:		window.FxOnlineStore.ajax_url,
	nonces: 		window.FxOnlineStore.nonces,


	/**
	 * Wrapper for fetch request
	 * 
	 * @param 	{string} 	action 		WP AJAX action
	 * @param 	{obj}		[ data ]	Optional data to append to request
	 * @param 	{string}	[ method ]	Request method (either GET or POST)
	 * 
	 * @return	{Promise}	Promise for actual fetch request's response
	 */			
	fetch( action, data = {}, method = 'get' ) {
		let params

		// allowed method?
		method = method.toLowerCase()
		if( 'get' !== method && 'post' !== method ) {
			throw Error( 'Invalid method' )
		}

		// normalize data object
		if( data instanceof URLSearchParams ) {
			params = data
		} else {
			params = new URLSearchParams()

			for( const [ key, value ] of Object.entries( data ) ) {
				params.append( key, value )
			}
		}

		// add action so WordPress knows what we're sending them
		params.set( 'action', `${this.ajaxNamespace}_${action}` )

		// conditionally add nonce
		if( Object.hasOwnProperty.call( this.nonces, action ) ) {
			params.set( '_fxos_nonce', this.nonces[ action ] )
		}

		return new Promise( ( resolve, reject ) => {
			let request

			if( 'get' === method ) {
				request = this.getFetch( params )
			} else {
				request = this.postFetch( params )
			}

			request
				.then( response => response.json() )
				.then( response => {
					resolve( response )

				}).catch( error => {
					console.warn( error )
					reject( false )
				})
		})
	},


	/**
	 * Generic GET fetch request
	 * 
	 * @param 	{obj} 		params 	Request parameters
	 * @return	{Promise}	Fetch request
	 */			
	getFetch( params ) {
		return fetch( `${this.ajaxUrl}?${params.toString()}` )
	},


	/**
	 * Generic POST fetch request
	 * 
	 * @param 	{obj} 	params 	Request parameters
	 * @return	{Promise}	Fetch request
	 */			
	postFetch( params ) {
		return fetch(
			this.ajaxUrl,
			{
				body: 		params.toString(),
				method: 	'post',
				headers: 	{
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
	},


	/**
	 * Specialized request to get updated nonces
	 * 
	 * @todo 	Still using this? (delete if not)
	 * 
	 * @param 	{obj}		params 	Request parameters
	 * @return	{Promise}	Fetch request
	 */		
	async refreshNonces() {
		const response = await this.fetch('refresh_nonces')

		const { data } = response
		
		// @todo — troubleshoot ref issues
		window.FxOnlineStore.nonces = data
		this.nonces = data
		
		return true
	}

}


export default FetchApi